import React, {useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import './Attribute.css';
import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import {initAttributeForm, onChangeAttributesForm, selAttributesForm} from "../../../stores/attributes/slice";
import {attributeValidations, FormAttributeInit} from "../../../stores/attributes/model";
import {createAttribute, getAttributeById} from "../../../stores/attributes/thunk";
import {Checkbox, FormControlLabel} from "@mui/material";


export default function Attribute() {

    const attribute = useSelector(selAttributesForm);
    const [test, setTest] = useState('');
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [allValues, setAllValues] = useState([]);
    const [checkEditor, setCheckEditor] = useState(false);
    const [valueForAddValue, setValueForAddValue] = useState("");
    const [allValuesForSend, setAllValuesForSend] = useState([]);


    const {errors, checkFiled, checkValidation} = useValidation({
        data: attributeValidations,
        key: 'attributeForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onChangeAttributesForm({name, value}))
    }

    function setToAllValue(e) {
        e.preventDefault();
        setAllValues([...allValues, valueForAddValue]);
        setValueForAddValue("");
        setAllValuesForSend([...allValuesForSend, valueForAddValue])
    }


    function backToAttributes() {
        history.push('/attributes');
    }

    const redirectToAttributes =()=> history.push("/attributes")

    function addAgency(){
        const data = {
            name: attribute.name,
            type_id : attribute.type.id,
            label : attribute.label ,
            has_editor: attribute.has_editor,
            description : attribute.description
        }
        dispatch(createAttribute(data, redirectToAttributes))
    }

    function putAgency(){
        const data = {
            name: attribute.name,
            type_id : attribute.type.id,
            label : attribute.label ,
            has_editor: attribute.has_editor,
            description : attribute.description
        }
        // dispatch(editAgency(id, data, backToAttributes))
    }



    useEffect(() => {
        id ?
            dispatch(getAttributeById(id))
            :
            dispatch(initAttributeForm(FormAttributeInit))
        return ()=>{
            dispatch(initAttributeForm(FormAttributeInit))
        }
    }, [id])


    const top100Films = [
        {name: 'text', id: 56},
        {name: 'date', id: 55},
        {name: 'dropdown', id: 57},
        {name: 'checkBox', id: 58},
        {name: 'pdf', id: 59},
    ];

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن ویژگی"
                backBtnTitle="بازگشت"
                backBtnAction={backToAttributes}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام قابل مشاهده'}
                                        variant="outlined"
                                        name={'name'}
                                        value={attribute.name}
                                        error={errors.name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        className={`w-100`}
                                        value={attribute?.type}
                                        options={top100Films}
                                        getOptionLabel={(option) => option.name ? option.name : ''}
                                        onChange={(event, value) => {
                                            checkFiled('type', value);
                                            dispatch(onChangeAttributesForm({name: 'type', value: value}))
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       error={errors?.province}
                                                       variant="outlined"
                                                       className={`w-100`}
                                                       label="نوع کامپوننت"/>
                                        )}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'Name Attribute(unique)'}
                                        variant="outlined"
                                        name={'label'}
                                        value={attribute.label}
                                        error={errors.label}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'توضیحات'}
                                        variant="outlined"
                                        name={'description'}
                                        value={attribute.description}
                                        error={errors.description}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={6} xl={8}
                                      className="d-flex justify-content-center align-items-center h-max"
                                >
                                    {(attribute?.type?.id === 57 || attribute?.type?.id === 58) &&
                                        <div className="ContentCreateAttribute pr-0 d-flex justify-content-between">
                                            <Grid item lg={12}>
                                                <div
                                                    className="d-flex flex-wrap parentAllUnitsValue"
                                                >
                                                    {allValues.map((data, i) => (
                                                        <div key={i} className="unitValueInInput">
                                                            <h3>{data}</h3>
                                                            <IconButton
                                                                aria-label="delete"
                                                                className="deleteValue"
                                                                onClick={() => {
                                                                    setAllValues(allValues.filter(x => x !== data))
                                                                }}>
                                                                <CloseIcon/>
                                                            </IconButton>
                                                        </div>
                                                    ))}
                                                    <button onClick={() => setOpen(!open)}>{open ? "بستن" : "افزودن"}</button>
                                                </div>
                                                <div className="d-flex flex-column align-items-center parentAddValueForAttribute">
                                                    {open ? (
                                                        <form className="d-flex flex-column mt-3" onSubmit={setToAllValue}>
                                                            <TextField
                                                                label="عنوان"
                                                                variant="outlined"
                                                                value={valueForAddValue}
                                                                onChange={(e) =>
                                                                    setValueForAddValue(e.target.value)
                                                                }
                                                            />
                                                        </form>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                        </div>
                                    }
                                    {attribute?.type?.id === 56 &&
                                    <div className="ParentCheckEditor">
                                        <FormControlLabel
                                            value={checkEditor}
                                            control={<Checkbox onChange={() => setCheckEditor(!checkEditor)}/>}
                                            label="داشتن چک ادیتور"
                                            labelPlacement="end"
                                        />
                                    </div>
                                    }
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putAgency : addAgency }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            ایجاد
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
